import {
  RequestReactivarTorneoAnterior,
  ResponseProfilePic,
  ResponseThumbsParticipants,
} from '../types/tda';

import { RequestCreateTDA } from '@/modules/tourneys/friends/CreateTournamentTDA';
import { GDTApiErrors } from '@/types';
import { ResponseBase } from '@/types/commons';
import {
  ApplicationResponseTDA,
  DatosBancariosBody,
  EnumFriendsTournamentType,
  ReponseConvertirTDAaVip,
  ReponseFechasDisponiblesTDA,
  ReponseNombreDisponibleTDA,
  ReponsePinesDisponiblesTDAVIP,
  ReponseSugerenciasTDA,
  ReponseValidacionPinesTDAVIP,
  ResponseAdminTda,
  ResponseInitTDA,
  ResponseListTDAP,
  ResponseObtenerDatosBancarios,
  ResponseRankingTda,
  TorneosAnteriores,
  ViewTDAResponse,
  ResponseGetPostsTDA,
  ResponsePostPostsTDA,
  RequestPostPostsTDA,
  ResponseCoverTda,
  ResponseSuggestionAutocomplete,
  ResponseTourneysExisting,
  ResponseListarTapsUsuario,
  ResponsePopupInscriptionData,
  ResponseInscribirseTap,
  ResponseTapTourneyData,
  ResponseDatosBasicosTDA,
  ResponseReactivarTorneoAnterior,
} from '@/types/tda';
import { TEXTS, URLs, axiosErrorHandler } from '@/utils';
import axiosGdt from '@/utils/axiosGdt';

// Enum for action types
export enum ActionTypeManageTDAEnum {
  Accept = 1,
  Reject = 2,
  AcceptInvitation = 3,
  RejectInvitation = 4,
}

export const getListTDA = axiosErrorHandler(async () => {
  const url = `${URLs.TORNEO_AMIGOS.LISTAR_TDAP}`;
  const response = await axiosGdt.get<ResponseListTDAP | GDTApiErrors>(url);

  return response.data;
}, TEXTS.defaultError);

export const getInitData = axiosErrorHandler(async () => {
  const url = `${URLs.TORNEO_AMIGOS.INIT}`;
  const response = await axiosGdt.get<ResponseInitTDA | GDTApiErrors>(url);

  return response.data;
}, TEXTS.defaultError);

export const getThumbsParticipants = axiosErrorHandler(async (id: number) => {
  const url = `${URLs.TORNEO_AMIGOS.GET_PARTICIPANTES}`;
  const response = await axiosGdt.get<
    ResponseThumbsParticipants | GDTApiErrors
  >(`${url}?id=${id}`);

  return response.data;
}, TEXTS.defaultError);

export const getRecommended = axiosErrorHandler(async () => {
  const url = `${URLs.TORNEO_AMIGOS.RECOMENDADOS}`;
  const response = await axiosGdt.get<ReponseSugerenciasTDA | GDTApiErrors>(
    url
  );

  return response.data;
}, TEXTS.defaultError);

export const getAdminTda = axiosErrorHandler(async (idTda: number) => {
  const url = `${URLs.TORNEO_AMIGOS.VER_ADMIN}`;

  const response = await axiosGdt.get<ResponseAdminTda | GDTApiErrors>(
    `${url}&idTorneoAdmin=${idTda}`
  );

  return response.data;
}, TEXTS.defaultError);

export const getPreviousTourneys = axiosErrorHandler(async () => {
  const url = `${URLs.TORNEO_AMIGOS.ANTERIORES}`;
  const response = await axiosGdt.get<TorneosAnteriores | GDTApiErrors>(url);

  return response.data;
}, TEXTS.defaultError);

export const getReactivateTorneys = axiosErrorHandler(async (id: number) => {
  const url = `${URLs.TORNEO_AMIGOS.REACTIVAR}`;
  const response = await axiosGdt.post<any | GDTApiErrors>(url, id);

  return response.data;
}, TEXTS.defaultError);

export const requestPostulationTda = axiosErrorHandler(async (id: number) => {
  const url = `${URLs.TORNEO_AMIGOS.POSTULARSE}`;
  const response = await axiosGdt.post<ApplicationResponseTDA>(
    `${url}&idTorneo=${id}`
  );

  return response.data;
}, TEXTS.defaultError);

export interface DataPostManageTDA {
  actionType: ActionTypeManageTDAEnum;
  idTourney: number;
  idUser?: number;
}

export const postManagePostulant = axiosErrorHandler(
  async (data: DataPostManageTDA) => {
    const { TRATAR_POSTULANTE } = URLs.TORNEO_AMIGOS;
    const { actionType, idTourney, idUser } = data;

    const params = new URLSearchParams({
      tipoAccion: actionType.toString(),
      idTorneo: idTourney.toString(),
      ...(actionType <= ActionTypeManageTDAEnum.Reject &&
        idUser && {
          idUsuario: idUser.toString(),
        }),
    });

    const response = await axiosGdt.post<ApplicationResponseTDA>(
      `${TRATAR_POSTULANTE}&${params.toString()}`
    );

    return response.data;
  },
  TEXTS.defaultError
);

export const postManageAllPostulant = axiosErrorHandler(
  async (idTourney: number) => {
    const { ACEPTAR_TODOS_POSTULANTES } = URLs.TORNEO_AMIGOS;

    const response = await axiosGdt.post<ResponseBase>(
      `${ACEPTAR_TODOS_POSTULANTES}&idTorneo=${idTourney}`
    );

    return response.data;
  },
  TEXTS.defaultError
);

export const requestExpelMember = axiosErrorHandler(
  async ({ idTourney, idUser }: { idUser: number; idTourney: number }) => {
    const params = new URLSearchParams({
      idUsuario: idUser.toString(),
      idTorneo: idTourney.toString(),
    });

    const response = await axiosGdt.post<ResponseBase>(
      `${URLs.TORNEO_AMIGOS.EXPULSAR_MIEMBRO}?${params}`
    );

    return response.data;
  },
  TEXTS.defaultError
);

export const registerTDA = axiosErrorHandler(async (data: RequestCreateTDA) => {
  const url = `${URLs.TORNEO_AMIGOS.CREAR_TORNEO}`;
  let params = `nombreTorneo=${data.tournamentName}&tipo=${data.tournamentType}&idFechaComienzo=${data.tournamentDate}`;
  if (
    data.tournamentType === EnumFriendsTournamentType.Vip &&
    !data.isPremiumUser
  ) {
    params += `&pin1=${data.pin1}&pin2=${data.pin2}`;
  }
  const response = await axiosGdt.post<ApplicationResponseTDA>(
    `${url}&${params}`
  );

  return response.data;
}, TEXTS.defaultError);

export const reactivateTDA = axiosErrorHandler(
  async ({
    idTA,
    nombreTA,
    ordenFechaInicioTDA,
    pin1,
    pin2,
    vip,
  }: RequestReactivarTorneoAnterior) => {
    const url = `${URLs.TORNEO_AMIGOS.REACTIVAR}`;
    const data = new URLSearchParams({
      nombreTA: String(nombreTA),
      tipo: String(vip),
      ordenFechaInicioTDA: String(ordenFechaInicioTDA),
      idTA: String(idTA),
    });
    if (vip && vip === EnumFriendsTournamentType.Vip) {
      data.set('pin1', String(pin1));
      data.set('pin2', String(pin2));
    }
    const response = await axiosGdt.post<ResponseReactivarTorneoAnterior>(
      url,
      data
    );

    return response.data;
  },
  TEXTS.defaultError
);

export const getFullInitTDA = axiosErrorHandler(async () => {
  const promise1: Promise<Promise<GDTApiErrors | ResponseInitTDA>> =
    getInitData();
  const promise2: Promise<Promise<GDTApiErrors | ReponseSugerenciasTDA>> =
    getRecommended();
  const [init, recommended] = await Promise.all([promise1, promise2]);
  return {
    init,
    recommended,
  };
}, 'Error al obtener datos');

export const getAvailableDatesTDA = axiosErrorHandler(async () => {
  const url = `${URLs.TORNEO_AMIGOS.FECHAS_DISPONIBLES}`;
  const response = await axiosGdt.get<
    ReponseFechasDisponiblesTDA | GDTApiErrors
  >(url);

  return response.data;
}, TEXTS.defaultError);

export const getAvailableNameTDA = axiosErrorHandler(
  async (tournamentName: string) => {
    const url = `${URLs.TORNEO_AMIGOS.VALIDAR_NOMBRE}`;
    const params = `nombre=${tournamentName}`;

    const response = await axiosGdt.get<
      ReponseNombreDisponibleTDA | GDTApiErrors
    >(`${url}?${params}`);

    return response.data;
  },
  TEXTS.defaultError
);

export const getTdaById = axiosErrorHandler(
  async (id: number, isF11: boolean, date?: number) => {
    const url = isF11
      ? `${URLs.TORNEO_AMIGOS.VER_TORNEO}`
      : `${URLs.TORNEO_AMIGOS.VER_TORNEO_F5}`;
    const params = `id=${id}&fecha=${date}`;

    const response = await axiosGdt.get<ViewTDAResponse | GDTApiErrors>(
      `${url}&${params}`
    );

    return response.data;
  },
  TEXTS.defaultError
);

/**
 * Datos básicos por ID
 * (para manejar invitación desde whatsapp)
 */
export const getTdaBasicDataById = async (id: number) => {
  const url = `${URLs.TORNEO_AMIGOS.DATOS_BASICOS}`;
  const params = `idTDA=${id}`;

  const response = await axiosGdt.get<ResponseDatosBasicosTDA | GDTApiErrors>(
    `${url}?${params}`
  );

  return response.data;
};

export const getRankingAvailable = axiosErrorHandler(
  async (initTDA: number) => {
    const url = `${URLs.TORNEO_AMIGOS.FECHAS_DISPONIBLES}`;
    const response = await axiosGdt.get<ResponseRankingTda | GDTApiErrors>(
      `${url}&ordenFechaITDA=${initTDA}`
    );

    return response.data;
  },
  TEXTS.defaultError
);

export const getAvailablePinsTDAVIP = axiosErrorHandler(async () => {
  const url = `${URLs.TORNEO_AMIGOS.SUGUERIR_PINES}`;

  const response = await axiosGdt.get<
    ReponsePinesDisponiblesTDAVIP | GDTApiErrors
  >(url);

  return response.data;
}, TEXTS.defaultError);

export const getPinsValidationTDAVIP = axiosErrorHandler(
  async (pin1: string, pin2: string) => {
    const url = `${URLs.TORNEO_AMIGOS.VALIDAR_PINES}`;

    const response = await axiosGdt.get<
      ReponseValidacionPinesTDAVIP | GDTApiErrors
    >(`${url}?pin1=${pin1}&pin2=${pin2}`);

    return response.data;
  },
  TEXTS.defaultError
);

export const changeTDAtoVip = axiosErrorHandler(
  async (pin1: string, pin2: string, tournamentId: number) => {
    const url = `${URLs.TORNEO_AMIGOS.CONVERTIR_TDA}`;
    const body = {
      idTDA: tournamentId,
      pin1,
      pin2,
    };
    const response = await axiosGdt.post<
      ReponseConvertirTDAaVip | GDTApiErrors
    >(url, body);

    return response.data;
  },
  TEXTS.defaultError
);

export const getDatosBancarios = axiosErrorHandler(async () => {
  const url = `${URLs.TORNEO_AMIGOS.OBTENER_DATOS_BANCARIOS}`;
  const response = await axiosGdt.get<ResponseObtenerDatosBancarios>(url);
  return response.data;
}, TEXTS.defaultError);

export const postDatosBancarios = axiosErrorHandler(
  async (value: DatosBancariosBody) => {
    const url = `${URLs.TORNEO_AMIGOS.GUARDAR_DATOS_BANCARIOS}`;
    const response = await axiosGdt.post<ResponseBase>(url, value, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      },
    });
    return response.data;
  },
  TEXTS.defaultError
);

export const getTdaChatPosts = axiosErrorHandler(async (tourneyId: number) => {
  const url = `${URLs.TORNEO_AMIGOS.OBTENER_POSTS_CHAT}`;
  const params = `&id=${tourneyId}`;
  const response = await axiosGdt.get<ResponseGetPostsTDA>(url + params);
  return response.data;
}, TEXTS.defaultError);

export const postTdaChatMessage = axiosErrorHandler(
  async ({ tournamentId, message }: RequestPostPostsTDA) => {
    const escapedMessage = encodeURIComponent(message);
    const url = `${URLs.TORNEO_AMIGOS.ENVIAR_POSTS_CHAT}`;
    const params = `&id=${tournamentId}&mensaje=${escapedMessage}`;
    const response = await axiosGdt.post<ResponsePostPostsTDA>(url + params);
    return response.data;
  },
  TEXTS.defaultError
);
/**
 * Upload foto de portada
 */
export const uploadCoverImage = axiosErrorHandler(
  async (blob: Blob, idTorneo: number) => {
    const url = `${URLs.TORNEO_AMIGOS.PORTADA_UPLOAD}&idTorneo=${idTorneo}`;
    const formData = new FormData();
    const fileName = `archivo.jpg`;
    const file = new File([blob], fileName);
    formData.append('archivo', file, fileName);

    const response = await axiosGdt.post<ResponseCoverTda>(url, formData, {
      headers: {
        'Content-Type': `multipart/form-data`,
      },
    });
    return response.data;
  },
  TEXTS.defaultError
);

/**
 * Elimina foto de portada (ambos modos)
 */
export const deleteCoverImage = axiosErrorHandler(async (idTorneo: number) => {
  const url = `${URLs.TORNEO_AMIGOS.PORTADA_DELETE}&idTorneo=${idTorneo}`;
  const response = await axiosGdt.post<ResponseBase>(url, undefined, {});
  return response.data;
}, TEXTS.defaultError);

/**
 * selecciona  foto de portada predefinida
 */
export const selectPredefinedCoverImage = axiosErrorHandler(
  async (idTorneo: number, idPortada: number) => {
    const url = `${URLs.TORNEO_AMIGOS.PORTADA_SELECT_PREDEFINED}`;
    const response = await axiosGdt.post<ResponseCoverTda>(
      url,
      {
        idPortada,
        idTorneo,
      },
      {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        },
      }
    );
    return response.data;
  },
  TEXTS.defaultError
);

/**
 * Upload foto de perfil
 */
export const uploadProfilePic = axiosErrorHandler(
  async (blob: Blob, idTorneo: number) => {
    const url = `${URLs.TORNEO_AMIGOS.UPLOAD_FOTO_PERFIL}&idTorneo=${idTorneo}`;
    const formData = new FormData();
    const fileName = `archivo.jpg`;
    const file = new File([blob], fileName);
    formData.append('archivo', file, fileName);

    const response = await axiosGdt.post<ResponseProfilePic>(url, formData, {
      headers: {
        'Content-Type': `multipart/form-data`,
      },
    });
    return response.data;
  },
  TEXTS.defaultError
);

/**
 * selecciona  foto de perfil predefinida
 */
export const setPredefinedProfilePic = axiosErrorHandler(
  async (idTorneo: number, idPredefinida: number) => {
    const url = `${URLs.TORNEO_AMIGOS.SET_FOTO_PERFIL_PREDEFINIDA}`;
    const response = await axiosGdt.post<ResponseProfilePic>(
      url,
      {
        idPredefinida,
        idTorneo,
      },
      {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        },
      }
    );
    return response.data;
  },
  TEXTS.defaultError
);

/**
 * cambia fecha de inicio de torneo
 */
export const changeInitDateTda = axiosErrorHandler(
  async (id: number, newDate: number) => {
    const url = `${URLs.TORNEO_AMIGOS.MODIFICAR_FECHA}&idTorneoAdmin=${id}&ordenFechaInicioTDA=${newDate}`;
    const response = await axiosGdt.post<GDTApiErrors>(url);
    return response.data;
  },
  TEXTS.defaultError
);

/**
 * cambia fecha de inicio de torneo
 */
export const changeNameTda = axiosErrorHandler(
  async (id: number, newName: string) => {
    const url = `${
      URLs.TORNEO_AMIGOS.MODIFICAR_NOMBRE
    }&idTorneoAdmin=${id}&nuevoNombre=${encodeURIComponent(newName)}`;
    const response = await axiosGdt.post<GDTApiErrors>(url);
    return response.data;
  },
  TEXTS.defaultError
);

export const postNameDateAdminTDA = axiosErrorHandler(
  async (id: number, newDate: number, newName: string) => {
    const promise1: Promise<Promise<GDTApiErrors>> = changeInitDateTda(
      id,
      newDate
    );
    const promise2: Promise<Promise<GDTApiErrors>> = changeNameTda(id, newName);
    const [responseDate, responseName] = await Promise.all([
      promise1,
      promise2,
    ]);
    return {
      responseDate,
      responseName,
    };
  },
  'Error al grabar datos de nombre y fecha'
);

// Pedido para autocompletado de busqueda de torneos existentes
export const requestTdaNameAutocomplete = axiosErrorHandler(
  async (term: string) => {
    const url = `${
      URLs.TORNEO_AMIGOS.AUTOCOMPLETE_NOMBRE_TDA
    }&term=${encodeURIComponent(term)}`;
    const response = await axiosGdt.post<ResponseSuggestionAutocomplete>(url);
    return response.data;
  },
  TEXTS.defaultError
);

export const requestTourneyDTsAutocomplete = axiosErrorHandler(
  async (term: string) => {
    const params = new URLSearchParams({
      term: encodeURIComponent(term),
    });
    const response = await axiosGdt.post<ResponseSuggestionAutocomplete>(
      URLs.TORNEO_AMIGOS.AUTOCOMPLETE_APELLIDO_DT,
      null,
      { params }
    );
    return response.data;
  },
  TEXTS.defaultError
);

export const requestAutocompleteSuggestions = axiosErrorHandler(
  async (nameTda: string, lastnameDt: string) => {
    const promise1: Promise<Promise<ResponseSuggestionAutocomplete>> =
      requestTdaNameAutocomplete(nameTda);
    const promise2: Promise<Promise<ResponseSuggestionAutocomplete>> =
      requestTourneyDTsAutocomplete(lastnameDt);
    const [responseTourneyName, responseTourneyDts] = await Promise.all([
      promise1,
      promise2,
    ]);
    return {
      responseTourneyName,
      responseTourneyDts,
    };
  },
  TEXTS.defaultError
);

export interface RequestTourneysExisting {
  nameTda?: string;
  name?: string;
  lastname?: string;
  perPage?: string;
  curPage?: string;
}

export const requestTourneysExisting = axiosErrorHandler(
  async ({
    nameTda,
    name,
    lastname,
    perPage,
    curPage,
  }: RequestTourneysExisting) => {
    const params = new URLSearchParams({
      nombreTorneo: nameTda || '',
      apellidoDueno: lastname || '',
      nombreDueno: name || '',
      cantPorPagina: perPage || '',
      paginaActual: curPage || '',
    });
    const url = `${URLs.TORNEO_AMIGOS.LISTA_TORNEOS}`;
    const response = await axiosGdt.post<ResponseTourneysExisting>(url, null, {
      params,
    });

    return response.data;
  },
  TEXTS.defaultError
);

// TDAxP ---------------------------------------------------------------------------------------------------------------

export const getTdaxPrizesList = axiosErrorHandler(async () => {
  const url = `${URLs.TORNEO_AMIGOS_PREMIOS.LISTA_TAP_USUARIO}`;

  const response = await axiosGdt.get<ResponseListarTapsUsuario>(url);
  return response.data;
}, TEXTS.defaultError);

export const popupInscriptionData = axiosErrorHandler(
  async (tourneyId: number) => {
    const url = `${URLs.TORNEO_AMIGOS_PREMIOS.DATOS_POPUP_INSCRIPCION}`;
    const params = `&idTA=${tourneyId}`;

    const response = await axiosGdt.get<ResponsePopupInscriptionData>(
      url + params
    );
    return response.data;
  },
  TEXTS.defaultError
);

export const TapRegistrationService = axiosErrorHandler(
  async (tourneyId: number, pin: string | undefined) => {
    const url = `${URLs.TORNEO_AMIGOS_PREMIOS.TAP_INSCRIPCION}`;
    const params = `&idTA=${tourneyId}${pin ? `&pin=${pin}` : ''}`;

    const response = await axiosGdt.get<ResponseInscribirseTap>(url + params);
    return response.data;
  },
  TEXTS.defaultError
);

export const viewTapTourneyData = axiosErrorHandler(
  async (tourneyId: number, idFecha: number) => {
    const url = `${URLs.TORNEO_AMIGOS_PREMIOS.VER_TAP}`;
    const params = `&id=${tourneyId}${idFecha ? `&fecha=${idFecha}` : ''}`;

    const response = await axiosGdt.get<ResponseTapTourneyData>(url + params);
    return response.data;
  },
  TEXTS.defaultError
);
